import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Download = forwardRef(({ color = "currentColor", size = 24, ...rest }, ref) => {
    const defaultAttrs = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color,
        ref,
        ...rest,
    };
    return (_jsx("svg", { ...defaultAttrs, children: _jsx("path", { clipRule: "evenodd", d: "m12 3c.5523 0 1 .44772 1 1v9.5858l3.2929-3.2929c.3905-.39053 1.0237-.39053 1.4142 0 .3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0l-5.00001-5c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.39053 1.02369-.39053 1.41422 0l3.29289 3.2929v-9.5858c0-.55228.4477-1 1-1zm-8 13c.55228 0 1 .4477 1 1v2c0 .2652.10536.5196.29289.7071.18754.1875.44189.2929.70711.2929h12c.2652 0 .5196-.1054.7071-.2929s.2929-.4419.2929-.7071v-2c0-.5523.4477-1 1-1s1 .4477 1 1v2c0 .7957-.3161 1.5587-.8787 2.1213s-1.3256.8787-2.1213.8787h-12c-.79565 0-1.55871-.3161-2.12132-.8787s-.87868-1.3256-.87868-2.1213v-2c0-.5523.44772-1 1-1z", fill: "currentColor", fillRule: "evenodd" }) }));
});
Download.displayName = "Download";
//# sourceMappingURL=Download.js.map